import { _detect } from "bowser";

export default function GeozonesListController($scope, $filter, equipmentGeozoneService, gettextCatalog) {

  'ngInject';

  //Local Variables
  $scope.searchText = "";
  $scope.selectedRow = "";
  $scope.geozoneList = [];
  $scope.filteredGeozones = [];

  //Pagination
  $scope.currentPage = 1;
  $scope.itemsPerPage = 15;
  $scope.maxSize = 1;

  //Sorting
  $scope.predicate = 'name';
  $scope.reverse = false;
  var orderBy = $filter('orderBy');


  //Sort filteredAlertRules
  $scope.orderGeozones = function (predicate) {

    if (predicate === $scope.predicate) {
      $scope.reverse = !$scope.reverse;
    } else {
      $scope.reverse = false;
    }
    $scope.predicate = predicate;
  };

  //applyFilter searchs the roles[] for anything matching the search input.
  $scope.applyFilter = function () {
    $scope.filteredGeozones = $filter('filter')($scope.geozoneList, $scope.searchText);
  };

  //Capture errors and display a message to the user below the form if errors exist
  $scope.errorFlag = false;
  $scope.errorText = "";
  $scope.loading = true;

  //reset flags after user selects a new row
  $scope.resetFlags = function () {
    $scope.errorFlag = false;
    $scope.errorText = "";
  };

  //Track the selected Group
  $scope.groupSelected = function (name) {
    $scope.selectedName = name;
  };

  //Tracks the selected row.
  $scope.setSelectedRow = function (name) {
    $scope.selectedRow = name;
    $scope.resetFlags();
  };

  //General Error Handler
  function handleError(error) {
    $scope.loading = false;

    var errorMsg = gettextCatalog.getString("An error occurred while retrieving GeoZones");
    if (error.data || error.status) {
      if (error.data.message) {
        errorMsg = error.data.message + " " + (error.status.toString() + " - " + error.statusText.toString());
      } else {
        errorMsg += ": " + (error.status.toString() + " - " + error.statusText.toString());
      }
    } else {
      errorMsg += gettextCatalog.getString(". Please try again later.");
    }
    $scope.onLoadErrorText = errorMsg;
    $scope.onLoadErrorFlag = true;
  }

  $scope.loading = true;

  equipmentGeozoneService.getAllGeozones().then((response) => {
    $scope.geozoneList = [...response.data];

    $scope.loading = false;
    // Wrap this inside of the service call for getAllGeozones
    $scope.filteredGeozones = $scope.geozoneList.slice();
    $scope.loading = false;
  }, handleError);

}